var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { headerBaseStyles, textBaseStyles } from './styles';
const TextBase = styled.span `
  ${textBaseStyles};
`;
const HeaderBase = styled.h1 `
  ${headerBaseStyles};
`;
/**
 * Used for body content.
 *
 * Defaults to size: 'sm', tag: 'span', weight: 'normal'
 */
const TextBody = React.forwardRef((_a, ref) => {
    var { id, children, className = '', outlineOnFocus = false, tabIndex, tag, size, weight = 'normal', style = 'inherit', type, focusOnMount, overflowWrap = 'break-word' } = _a, props = __rest(_a, ["id", "children", "className", "outlineOnFocus", "tabIndex", "tag", "size", "weight", "style", "type", "focusOnMount", "overflowWrap"]);
    const handleFocusOnMount = React.useCallback((node) => {
        if (node) {
            node.focus();
        }
    }, []);
    return (React.createElement(TextBase, Object.assign({ fontWeight: weight, fontStyle: style, ref: focusOnMount ? handleFocusOnMount : ref, className: className, as: tag, outlineOnFocus: outlineOnFocus, textStyle: type, overflowWrap: overflowWrap, size: size, tabIndex: focusOnMount ? -1 : tabIndex }, (id && { id }), props), children));
});
// for now so we can see the props table
export const TextBodyForProps = (props) => props && null;
const TextHeading = React.forwardRef((_a, ref) => {
    var { id, children, className = '', outlineOnFocus = false, tabIndex, tag, size = 'md', weight = 'bold', focusOnMount, dataAnchorId, overflowWrap, style = 'inherit' } = _a, props = __rest(_a, ["id", "children", "className", "outlineOnFocus", "tabIndex", "tag", "size", "weight", "focusOnMount", "dataAnchorId", "overflowWrap", "style"]);
    const handleFocusOnMount = React.useCallback((node) => {
        if (node) {
            node.focus();
        }
    }, []);
    return (React.createElement(HeaderBase, Object.assign({ fontWeight: weight, fontStyle: style, ref: focusOnMount ? handleFocusOnMount : ref, className: className, as: tag, outlineOnFocus: outlineOnFocus, overflowWrap: overflowWrap, tabIndex: focusOnMount ? -1 : tabIndex, "data-anchor-id": dataAnchorId, size: size }, (id && { id }), props), children));
});
// for now so we can see the props table
export const TextHeadingForProps = (props) => props && null;
export { TextBody, TextHeading };
//# sourceMappingURL=Text.js.map